import {ellipsize} from 'util/NameUtil';

export const EDGE_LABEL_MAX_LENGTH = 18;

export default function maybeEllipsizeLabel(label: string): string {
  if (label.length > EDGE_LABEL_MAX_LENGTH) {
    return ellipsize(label, EDGE_LABEL_MAX_LENGTH);
  }
  return label;
}
